<app-access-item>
  <app-access-item-icon>
    <app-gallery-settings-icon src="/assets/icons/layout-spacing-asset.svg"> </app-gallery-settings-icon>
  </app-access-item-icon>
  <app-access-item-header>
    <div>Spacing</div>
  </app-access-item-header>

  <app-access-item-cta>
    <div class="slider">
      <input
        type="range"
        [ngModel]="theme().section.spacing"
        [min]="0"
        [max]="50"
        (ngModelChange)="updateSpacing($event)"
      />
      <label></label>
    </div>
  </app-access-item-cta>
</app-access-item>
